// extracted by mini-css-extract-plugin
module.exports = {"PropertiesContainer":"PropertyList_PropertiesContainer__pE5Ed"};